export { e as BASE_PATH, B as BaseAPI, C as COLLECTION_FORMATS, D as DUMMY_BASE_URL, R as RequiredError, a as assertParamExists, d as createRequestFunction, o as operationServerMap, c as serializeDataIfNeeded, f as setApiKeyToObject, g as setBasicAuthToObject, s as setBearerAuthToObject, h as setOAuthToObject, b as setSearchParams, t as toPathString } from './common-BuhUSHAi.js';
import 'axios';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class Configuration {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    apiKey;
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    username;
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    password;
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    accessToken;
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    basePath;
    /**
     * override server index
     *
     * @type {number}
     * @memberof Configuration
     */
    serverIndex;
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    baseOptions;
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    formDataCtor;
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.serverIndex = param.serverIndex;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Discriminates a `CustomerAccessRule` as a whitelist (Allow) or blacklist (Deny) entry. Default is BizWeb.NC.Base.Enumerations.AccessRuleType.Allow so pre-existing rules keep their original whitelist semantics.
 * @export
 * @enum {number}
 */
var AccessRuleType;
(function (AccessRuleType) {
    AccessRuleType[AccessRuleType["Allow"] = 0] = "Allow";
    AccessRuleType[AccessRuleType["Deny"] = 1] = "Deny";
    /**
    * Default value for unknown data
    */
    AccessRuleType[AccessRuleType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(AccessRuleType || (AccessRuleType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var Action;
(function (Action) {
    Action[Action["Import"] = 1] = "Import";
    Action[Action["Export"] = 2] = "Export";
    /**
    * Default value for unknown data
    */
    Action[Action["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(Action || (Action = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of action recorded in `ActivityLogs` (BW-4412).
 * @export
 * @enum {number}
 */
var ActivityAction;
(function (ActivityAction) {
    ActivityAction[ActivityAction["Insert"] = 0] = "Insert";
    ActivityAction[ActivityAction["Update"] = 1] = "Update";
    ActivityAction[ActivityAction["Delete"] = 2] = "Delete";
    ActivityAction[ActivityAction["Restore"] = 3] = "Restore";
    ActivityAction[ActivityAction["Login"] = 4] = "Login";
    ActivityAction[ActivityAction["Logout"] = 5] = "Logout";
    ActivityAction[ActivityAction["LoginFailed"] = 6] = "LoginFailed";
    ActivityAction[ActivityAction["ImpersonationStart"] = 7] = "ImpersonationStart";
    /**
    * Default value for unknown data
    */
    ActivityAction[ActivityAction["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ActivityAction || (ActivityAction = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ApplyToSiteMode;
(function (ApplyToSiteMode) {
    ApplyToSiteMode[ApplyToSiteMode["_Undefined_"] = 0] = "_Undefined_";
    ApplyToSiteMode[ApplyToSiteMode["AllSites"] = 1] = "AllSites";
    ApplyToSiteMode[ApplyToSiteMode["DefaultSite"] = 2] = "DefaultSite";
    /**
    * Default value for unknown data
    */
    ApplyToSiteMode[ApplyToSiteMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ApplyToSiteMode || (ApplyToSiteMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var AttributeType;
(function (AttributeType) {
    AttributeType[AttributeType["SingleValue"] = 1] = "SingleValue";
    AttributeType[AttributeType["ListOfValues"] = 2] = "ListOfValues";
    /**
    * Default value for unknown data
    */
    AttributeType[AttributeType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(AttributeType || (AttributeType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The kind of actor behind an activity entry (BW-4412).
 * @export
 * @enum {number}
 */
var AuditActorKind;
(function (AuditActorKind) {
    /**
    * No signed-in user (scheduled job, hosted service, internal call).
    */
    AuditActorKind[AuditActorKind["System"] = 0] = "System";
    /**
    * Back-office user — the only actor logged in phase 1 (BizUserType.User).
    */
    AuditActorKind[AuditActorKind["User"] = 1] = "User";
    AuditActorKind[AuditActorKind["Customer"] = 2] = "Customer";
    AuditActorKind[AuditActorKind["CustomerEmployee"] = 3] = "CustomerEmployee";
    AuditActorKind[AuditActorKind["SalesPerson"] = 4] = "SalesPerson";
    AuditActorKind[AuditActorKind["ApiKey"] = 5] = "ApiKey";
    /**
    * Default value for unknown data
    */
    AuditActorKind[AuditActorKind["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(AuditActorKind || (AuditActorKind = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus[AvailabilityStatus["OnLineWarehouse"] = 0] = "OnLineWarehouse";
    AvailabilityStatus[AvailabilityStatus["Available"] = 1] = "Available";
    AvailabilityStatus[AvailabilityStatus["Limited"] = 2] = "Limited";
    AvailabilityStatus[AvailabilityStatus["Exhausted"] = 3] = "Exhausted";
    AvailabilityStatus[AvailabilityStatus["PreOrder"] = 4] = "PreOrder";
    AvailabilityStatus[AvailabilityStatus["AfterOrder"] = 5] = "AfterOrder";
    AvailabilityStatus[AvailabilityStatus["Days_1_3"] = 6] = "Days_1_3";
    AvailabilityStatus[AvailabilityStatus["Days_2_5"] = 7] = "Days_2_5";
    AvailabilityStatus[AvailabilityStatus["Days_4_7"] = 8] = "Days_4_7";
    AvailabilityStatus[AvailabilityStatus["Days_7_Over"] = 9] = "Days_7_Over";
    AvailabilityStatus[AvailabilityStatus["LastItem"] = 10] = "LastItem";
    AvailabilityStatus[AvailabilityStatus["NotAvailable"] = 11] = "NotAvailable";
    AvailabilityStatus[AvailabilityStatus["ComingSoon"] = 12] = "ComingSoon";
    AvailabilityStatus[AvailabilityStatus["OnStock"] = 13] = "OnStock";
    /**
    * Default value for unknown data
    */
    AvailabilityStatus[AvailabilityStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(AvailabilityStatus || (AvailabilityStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var BannerPersonsEntityType;
(function (BannerPersonsEntityType) {
    BannerPersonsEntityType[BannerPersonsEntityType["Inspector"] = 0] = "Inspector";
    BannerPersonsEntityType[BannerPersonsEntityType["SalesPerson"] = 1] = "SalesPerson";
    BannerPersonsEntityType[BannerPersonsEntityType["Customer"] = 2] = "Customer";
    /**
    * Default value for unknown data
    */
    BannerPersonsEntityType[BannerPersonsEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(BannerPersonsEntityType || (BannerPersonsEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var BinaryRepoEntityType;
(function (BinaryRepoEntityType) {
    BinaryRepoEntityType[BinaryRepoEntityType["None"] = 0] = "None";
    BinaryRepoEntityType[BinaryRepoEntityType["Banner"] = 1] = "Banner";
    BinaryRepoEntityType[BinaryRepoEntityType["ContentPage"] = 2] = "ContentPage";
    BinaryRepoEntityType[BinaryRepoEntityType["NewsEntry"] = 3] = "NewsEntry";
    BinaryRepoEntityType[BinaryRepoEntityType["Attribute"] = 4] = "Attribute";
    BinaryRepoEntityType[BinaryRepoEntityType["Category"] = 5] = "Category";
    BinaryRepoEntityType[BinaryRepoEntityType["Product"] = 6] = "Product";
    BinaryRepoEntityType[BinaryRepoEntityType["Status"] = 7] = "Status";
    BinaryRepoEntityType[BinaryRepoEntityType["Dimension"] = 8] = "Dimension";
    BinaryRepoEntityType[BinaryRepoEntityType["ProductDimension"] = 9] = "ProductDimension";
    BinaryRepoEntityType[BinaryRepoEntityType["ProductTab"] = 10] = "ProductTab";
    BinaryRepoEntityType[BinaryRepoEntityType["PaymentType"] = 11] = "PaymentType";
    BinaryRepoEntityType[BinaryRepoEntityType["ContactMail"] = 12] = "ContactMail";
    BinaryRepoEntityType[BinaryRepoEntityType["TakeAwayStore"] = 13] = "TakeAwayStore";
    BinaryRepoEntityType[BinaryRepoEntityType["AttributeValue"] = 14] = "AttributeValue";
    BinaryRepoEntityType[BinaryRepoEntityType["MenuItem"] = 15] = "MenuItem";
    BinaryRepoEntityType[BinaryRepoEntityType["Editor"] = 16] = "Editor";
    BinaryRepoEntityType[BinaryRepoEntityType["Manufacturer"] = 17] = "Manufacturer";
    BinaryRepoEntityType[BinaryRepoEntityType["Event"] = 18] = "Event";
    BinaryRepoEntityType[BinaryRepoEntityType["ShippingType"] = 19] = "ShippingType";
    BinaryRepoEntityType[BinaryRepoEntityType["Video"] = 20] = "Video";
    BinaryRepoEntityType[BinaryRepoEntityType["Notification"] = 21] = "Notification";
    BinaryRepoEntityType[BinaryRepoEntityType["Contributors"] = 22] = "Contributors";
    BinaryRepoEntityType[BinaryRepoEntityType["Award"] = 23] = "Award";
    BinaryRepoEntityType[BinaryRepoEntityType["Customers"] = 24] = "Customers";
    BinaryRepoEntityType[BinaryRepoEntityType["PromotionPolicy"] = 25] = "PromotionPolicy";
    BinaryRepoEntityType[BinaryRepoEntityType["SocialMedia"] = 26] = "SocialMedia";
    BinaryRepoEntityType[BinaryRepoEntityType["Logo"] = 27] = "Logo";
    BinaryRepoEntityType[BinaryRepoEntityType["Partner"] = 28] = "Partner";
    BinaryRepoEntityType[BinaryRepoEntityType["ProductTabEntry"] = 29] = "ProductTabEntry";
    BinaryRepoEntityType[BinaryRepoEntityType["BuyGuide"] = 31] = "BuyGuide";
    BinaryRepoEntityType[BinaryRepoEntityType["ReturnRequestItem"] = 32] = "ReturnRequestItem";
    BinaryRepoEntityType[BinaryRepoEntityType["FooterItem"] = 33] = "FooterItem";
    BinaryRepoEntityType[BinaryRepoEntityType["BookingType"] = 34] = "BookingType";
    BinaryRepoEntityType[BinaryRepoEntityType["Review"] = 35] = "Review";
    BinaryRepoEntityType[BinaryRepoEntityType["Temp"] = 2147483647] = "Temp";
    /**
    * Default value for unknown data
    */
    BinaryRepoEntityType[BinaryRepoEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(BinaryRepoEntityType || (BinaryRepoEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var BizUserType;
(function (BizUserType) {
    BizUserType[BizUserType["User"] = 0] = "User";
    BizUserType[BizUserType["Customer"] = 1] = "Customer";
    BizUserType[BizUserType["Employee"] = 2] = "Employee";
    BizUserType[BizUserType["SalesPerson"] = 3] = "SalesPerson";
    /**
    * Default value for unknown data
    */
    BizUserType[BizUserType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(BizUserType || (BizUserType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var BizwebEntityType;
(function (BizwebEntityType) {
    BizwebEntityType[BizwebEntityType["System"] = 0] = "System";
    BizwebEntityType[BizwebEntityType["Product"] = 1] = "Product";
    BizwebEntityType[BizwebEntityType["ProductCategory"] = 2] = "ProductCategory";
    BizwebEntityType[BizwebEntityType["Customer"] = 3] = "Customer";
    BizwebEntityType[BizwebEntityType["CustomerCategory"] = 4] = "CustomerCategory";
    BizwebEntityType[BizwebEntityType["Order"] = 5] = "Order";
    BizwebEntityType[BizwebEntityType["Contributor"] = 6] = "Contributor";
    BizwebEntityType[BizwebEntityType["Categories"] = 7] = "Categories";
    BizwebEntityType[BizwebEntityType["OrderLine"] = 8] = "OrderLine";
    BizwebEntityType[BizwebEntityType["CustomerGroup"] = 9] = "CustomerGroup";
    BizwebEntityType[BizwebEntityType["NewEntry"] = 10] = "NewEntry";
    BizwebEntityType[BizwebEntityType["Video"] = 11] = "Video";
    BizwebEntityType[BizwebEntityType["Review"] = 12] = "Review";
    BizwebEntityType[BizwebEntityType["PaymentType"] = 13] = "PaymentType";
    BizwebEntityType[BizwebEntityType["ShippingType"] = 14] = "ShippingType";
    BizwebEntityType[BizwebEntityType["ShippingCharge"] = 15] = "ShippingCharge";
    BizwebEntityType[BizwebEntityType["ContentPage"] = 16] = "ContentPage";
    BizwebEntityType[BizwebEntityType["Manufacturers"] = 17] = "Manufacturers";
    BizwebEntityType[BizwebEntityType["SocialMedia"] = 18] = "SocialMedia";
    BizwebEntityType[BizwebEntityType["Logo"] = 19] = "Logo";
    BizwebEntityType[BizwebEntityType["ProductDimension"] = 20] = "ProductDimension";
    BizwebEntityType[BizwebEntityType["ProductStockSnapshot"] = 22] = "ProductStockSnapshot";
    BizwebEntityType[BizwebEntityType["Banner"] = 23] = "Banner";
    BizwebEntityType[BizwebEntityType["Partner"] = 10018] = "Partner";
    /**
    * Default value for unknown data
    */
    BizwebEntityType[BizwebEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(BizwebEntityType || (BizwebEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var CardNotificationsStatus;
(function (CardNotificationsStatus) {
    CardNotificationsStatus[CardNotificationsStatus["NotSet"] = 0] = "NotSet";
    CardNotificationsStatus[CardNotificationsStatus["Pending"] = 1] = "Pending";
    CardNotificationsStatus[CardNotificationsStatus["Completed"] = 2] = "Completed";
    CardNotificationsStatus[CardNotificationsStatus["Cancelled"] = 3] = "Cancelled";
    /**
    * Default value for unknown data
    */
    CardNotificationsStatus[CardNotificationsStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CardNotificationsStatus || (CardNotificationsStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var CategoryFilterMode;
(function (CategoryFilterMode) {
    CategoryFilterMode[CategoryFilterMode["Subcategories"] = 0] = "Subcategories";
    CategoryFilterMode[CategoryFilterMode["Siblings"] = 1] = "Siblings";
    CategoryFilterMode[CategoryFilterMode["ByLevel"] = 2] = "ByLevel";
    /**
    * Default value for unknown data
    */
    CategoryFilterMode[CategoryFilterMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CategoryFilterMode || (CategoryFilterMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Ο τρόπος με τον οποίο συνδυάζονται κάποιες συνθήκες (Η/ΚΑΙ)
 * @export
 * @enum {number}
 */
var ConditionCombinationMode;
(function (ConditionCombinationMode) {
    /**
    * Δίνοντας αυτήν την τιμή, ο αλγόριθμος συνδυάζει τις συνθήκες με τον default τρόπο (όποιος είναι αυτός για τον εκάστοτε αλγόριθμο)
    */
    ConditionCombinationMode[ConditionCombinationMode["Default"] = 0] = "Default";
    /**
    * Συνδυασμός συνθηκών με Η (να ισχύει έστω μία)
    */
    ConditionCombinationMode[ConditionCombinationMode["Or"] = 1] = "Or";
    /**
    * Συνδυασμός συνθηκών με ΚΑΙ (να ισχύουν όλες)
    */
    ConditionCombinationMode[ConditionCombinationMode["And"] = 2] = "And";
    ConditionCombinationMode[ConditionCombinationMode["__Ignore"] = -2147483648] = "__Ignore";
    /**
    * Default value for unknown data
    */
    ConditionCombinationMode[ConditionCombinationMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ConditionCombinationMode || (ConditionCombinationMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ContactMethod;
(function (ContactMethod) {
    ContactMethod[ContactMethod["Email"] = 0] = "Email";
    ContactMethod[ContactMethod["Mobile"] = 1] = "Mobile";
    /**
    * Default value for unknown data
    */
    ContactMethod[ContactMethod["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ContactMethod || (ContactMethod = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var CouponEventType;
(function (CouponEventType) {
    /**
    * Όταν γίνεται χρήση του κουπονιού σε κάποια παραγγελία
    */
    CouponEventType[CouponEventType["Redeem"] = 0] = "Redeem";
    /**
    * Όταν γίνεται ακύρωση της παραγγελίας
    */
    CouponEventType[CouponEventType["Cancel"] = 1] = "Cancel";
    /**
    * Default value for unknown data
    */
    CouponEventType[CouponEventType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CouponEventType || (CouponEventType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var CouponValidationErrorCode;
(function (CouponValidationErrorCode) {
    /**
    * Το κουπόνι δεν βρέθηκε
    */
    CouponValidationErrorCode["NotFound"] = "NotFound";
    /**
    * Το κουπόνι είναι ανενεργό
    */
    CouponValidationErrorCode["Inactive"] = "Inactive";
    /**
    * Το κουπόνι έχει λήξει
    */
    CouponValidationErrorCode["Expired"] = "Expired";
    /**
    * Το κουπόνι δεν μπορεί ακόμα να χρησιμοποιηθεί. Συμβαίνει όταν το κουπόνι έχει ημερομηνία έναρξης χρήσης και γίνεται προσπάθεια χρήσης πριν από αυτήν την ημερομηνία
    */
    CouponValidationErrorCode["Pending"] = "Pending";
    /**
    * Το κουπόνι έχει καταναλωθεί
    */
    CouponValidationErrorCode["Redeemed"] = "Redeemed";
    /**
    * Το κουπόνι δεν μπορεί να εφαρμοστεί στον πελάτη λόγω περιορισμών στα email για τα οποία είναι ενεργό
    */
    CouponValidationErrorCode["EmailNotAllowed"] = "EmailNotAllowed";
    /**
    * Το κουπόνι δεν μπορεί να εφαρμοστεί στην παραγγελία
    */
    CouponValidationErrorCode["NotApplicable"] = "NotApplicable";
    /**
    * Παρουσιάστηκε συστημικό πρόβλημα κατά το validation του κουπονιού
    */
    CouponValidationErrorCode["InternalError"] = "InternalError";
    /**
    * Το κουπόνι πρέπει να εφαρμοστεί όταν υπάρχει e-mail ή logged in χρήστης
    */
    CouponValidationErrorCode["MustHaveEmailOrCustomerId"] = "MustHaveEmailOrCustomerId";
    /**
    * Το κουπόνι δεν μπορεί να χρησιμοποιηθεί από τον τρέχοντα πελάτη λόγω περιορισμών σε συγκεκριμένους πελάτες ή κατηγορίες
    */
    CouponValidationErrorCode["CustomerNotAllowed"] = "CustomerNotAllowed";
    /**
    * Το σύνολο της παραγγελίας δεν καλύπτει το ελάχιστο όριο εφαρμογής του κουπονιού
    */
    CouponValidationErrorCode["OrderAmountBelowThreshold"] = "OrderAmountBelowThreshold";
    /**
    * Το σύνολο των μη εκπτωτικών προϊόντων δεν καλύπτει το ελάχιστο όριο εφαρμογής του κουπονιού
    */
    CouponValidationErrorCode["OrderNonDiscountedAmountBelowThreshold"] = "OrderNonDiscountedAmountBelowThreshold";
    /**
    * Δεν υπάρχει προϊόν στο καλάθι που να καλύπτει τις προϋποθέσεις του κουπονιού
    */
    CouponValidationErrorCode["NoDiscountableItems"] = "NoDiscountableItems";
    /**
    * Δεν υπάρχει διαθέσιμο ποσό για να εφαρμοστεί η έκπτωση του κουπονιού
    */
    CouponValidationErrorCode["NoRemainingDiscountAmount"] = "NoRemainingDiscountAmount";
    /**
    * Το ποσό του κουπονιού είναι μεγαλύτερο από το διαθέσιμο προς έκπτωση ποσό της παραγγελίας
    */
    CouponValidationErrorCode["CouponValueExceedsOrderTotal"] = "CouponValueExceedsOrderTotal";
    /**
    * Υπάρχει ήδη καλύτερη έκπτωση στη γραμμή ή την παραγγελία από άλλη προωθητική ενέργεια
    */
    CouponValidationErrorCode["BetterDiscountAlreadyApplied"] = "BetterDiscountAlreadyApplied";
    /**
    * Δεν υπάρχουν μεταφορικά προς έκπτωση
    */
    CouponValidationErrorCode["NoShippingFeeToDiscount"] = "NoShippingFeeToDiscount";
    /**
    * Το κουπόνι ισχύει μόνο για συνδεδεμένους (logged-in) πελάτες και ο χρήστης είναι guest
    */
    CouponValidationErrorCode["LoggedInCustomerRequired"] = "LoggedInCustomerRequired";
    /**
    * Default value for unknown data
    */
    CouponValidationErrorCode["unknown_default_open_api"] = "11184809";
})(CouponValidationErrorCode || (CouponValidationErrorCode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents the custom content types supported by bizweb.
 * @export
 * @enum {number}
 */
var CustomContentSchema;
(function (CustomContentSchema) {
    /**
    * Represents a string of HTML content. (This is the default value for content)
    */
    CustomContentSchema[CustomContentSchema["Html"] = 0] = "Html";
    /**
    * Represents a string of plain text content.
    */
    CustomContentSchema[CustomContentSchema["PlainText"] = 1] = "PlainText";
    /**
    * Represents a string of Markdown content.
    */
    CustomContentSchema[CustomContentSchema["Markdown"] = 2] = "Markdown";
    /**
    * Represents a string of serialized Puck editor content state.
    */
    CustomContentSchema[CustomContentSchema["PuckEditor"] = 3] = "PuckEditor";
    /**
    * Represents a string of serialized Lexical content state.
    */
    CustomContentSchema[CustomContentSchema["Lexical"] = 4] = "Lexical";
    /**
    * Default value for unknown data
    */
    CustomContentSchema[CustomContentSchema["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CustomContentSchema || (CustomContentSchema = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var CustomDeleteBehavior;
(function (CustomDeleteBehavior) {
    CustomDeleteBehavior[CustomDeleteBehavior["Default"] = 0] = "Default";
    CustomDeleteBehavior[CustomDeleteBehavior["RemoveSubItems"] = 1] = "RemoveSubItems";
    CustomDeleteBehavior[CustomDeleteBehavior["KeepSubItems"] = 2] = "KeepSubItems";
    /**
    * Default value for unknown data
    */
    CustomDeleteBehavior[CustomDeleteBehavior["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CustomDeleteBehavior || (CustomDeleteBehavior = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var CustomerTierCriteriaType;
(function (CustomerTierCriteriaType) {
    CustomerTierCriteriaType[CustomerTierCriteriaType["LoyaltyPoints"] = 0] = "LoyaltyPoints";
    CustomerTierCriteriaType[CustomerTierCriteriaType["TotalPurchases"] = 1] = "TotalPurchases";
    /**
    * Default value for unknown data
    */
    CustomerTierCriteriaType[CustomerTierCriteriaType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(CustomerTierCriteriaType || (CustomerTierCriteriaType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var DimensionType;
(function (DimensionType) {
    /**
    * Custom dimension
    */
    DimensionType[DimensionType["Custom"] = 0] = "Custom";
    /**
    * Color dimension
    */
    DimensionType[DimensionType["Color"] = 1] = "Color";
    /**
    * Size dimension
    */
    DimensionType[DimensionType["Size"] = 2] = "Size";
    /**
    * Default value for unknown data
    */
    DimensionType[DimensionType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DimensionType || (DimensionType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var DimensionValueGroupingType;
(function (DimensionValueGroupingType) {
    DimensionValueGroupingType[DimensionValueGroupingType["None"] = 0] = "None";
    DimensionValueGroupingType[DimensionValueGroupingType["Footwear"] = 1] = "Footwear";
    DimensionValueGroupingType[DimensionValueGroupingType["Clothing"] = 2] = "Clothing";
    DimensionValueGroupingType[DimensionValueGroupingType["Color"] = 3] = "Color";
    DimensionValueGroupingType[DimensionValueGroupingType["Size"] = 4] = "Size";
    /**
    * Default value for unknown data
    */
    DimensionValueGroupingType[DimensionValueGroupingType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DimensionValueGroupingType || (DimensionValueGroupingType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Καθορίζει πώς θα εφαρμοστεί η έκπτωση του κουπονιού/πολιτικής σε ένα προϊόν που έχει ήδη έκπτωση στον τιμοκατάλογο.
 * @export
 * @enum {number}
 */
var DiscountApplicationMethod;
(function (DiscountApplicationMethod) {
    /**
    * Εφαρμόζεται μόνο η έκπτωση τιμοκαταλόγου. Η έκπτωση του κουπονιού/πολιτικής αγνοείται.
            Η τελική τιμή που προκύπτει είναι (αρχική τιμή - έκπτωση τιμοκαταλόγου). Αυτή που υπάρχει ήδη
    */
    DiscountApplicationMethod[DiscountApplicationMethod["ProductOnly"] = 0] = "ProductOnly";
    /**
    * Εφαρμόζεται μόνο η έκπτωση του κουπονιού/πολιτικής στην αρχική τιμή και η έκπτωση τιμοκαταλόγου αγνοείται.
            Η τελική τιμή που προκύπτει είναι (αρχική τιμή - έκπτωση κουπονιού/πολιτικής)
    */
    DiscountApplicationMethod[DiscountApplicationMethod["CouponOnly"] = 1] = "CouponOnly";
    /**
    * Εφαρμόζεται μόνο η μέγιστη από τις δύο εκπτώσεις (κουπονιού/πολιτικής ή προϊόντος) στην αρχική τιμή του προϊόντος.
            Η τελική τιμή που προκύπτει είναι (αρχική τιμή - MAX(έκπτωση κουπονιού/πολιτικής, έκπτωση τιμοκαταλόγου))
    */
    DiscountApplicationMethod[DiscountApplicationMethod["Maximum"] = 2] = "Maximum";
    /**
    * Εφαρμόζονται και οι δύο εκπτώσεις αρθοιστικά (ως ποσοστά) στην αρχική τιμή του προϊόντος.
            Προφανώς με μέγιστο 100%
            Η τελική τιμή που προκύπτει είναι (αρχική τιμή - MIN(100%, έκπτωση κουπονιού/πολιτικής + έκπτωση τιμοκαταλόγου)).
            Η επιλογή αυτή ισοδυναμεί με εφαρμογή του κουπονιού/πολιτικής στην αρχική τιμή του προϊόντος
    */
    DiscountApplicationMethod[DiscountApplicationMethod["Additive"] = 3] = "Additive";
    /**
    * Εφαρμόζονται και οι δύο εκπτώσεις. Πρώτη η έκπτωση τιμοκαταλόγου και στο αποτέλεσμα η έκπτωση του κουπονιού/πολιτικήςΗ τελική τιμή που προκύπτει είναι &#x3D; (Αρχική τιμή - έκπτωση τιμοκαταλόγου - (έκπτωση κουπονιού/πολιτικής επί της τιμής μετά έκτπωσης προϊόντος))Η επιλογή αυτή ισοδυναμεί με εφαρμογή του κουπονιού/πολιτικής στην τιμή του προϊόντος μετά την έκπτωση τιμοκαταλόγου
    */
    DiscountApplicationMethod[DiscountApplicationMethod["Multiplicative"] = 4] = "Multiplicative";
    /**
    * Default value for unknown data
    */
    DiscountApplicationMethod[DiscountApplicationMethod["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DiscountApplicationMethod || (DiscountApplicationMethod = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The base price used when evaluating a percentage or fixed-amount discount cap. Does not apply to minimum final price caps, which are self-defining.
 * @export
 * @enum {number}
 */
var DiscountCapBasis;
(function (DiscountCapBasis) {
    /**
    * Cap is evaluated against the product&#39;s unit price before any pricelist discount.
    */
    DiscountCapBasis[DiscountCapBasis["InitialPriceBeforePricelist"] = 0] = "InitialPriceBeforePricelist";
    /**
    * Cap is evaluated against the unit price after the pricelist discount has been applied.
    */
    DiscountCapBasis[DiscountCapBasis["PriceAfterPricelist"] = 1] = "PriceAfterPricelist";
    /**
    * Default value for unknown data
    */
    DiscountCapBasis[DiscountCapBasis["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DiscountCapBasis || (DiscountCapBasis = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Identifies which constraint of a `DiscountCap` record produced the most-restrictive minimum final unit price when the cap was evaluated for a cart item.
 * @export
 * @enum {number}
 */
var DiscountCapConstraint;
(function (DiscountCapConstraint) {
    /**
    * The cap&#39;s MaxDiscountPercentage was the binding constraint.
    */
    DiscountCapConstraint[DiscountCapConstraint["MaxDiscountPercentage"] = 1] = "MaxDiscountPercentage";
    /**
    * The cap&#39;s MaxDiscountAmount was the binding constraint.
    */
    DiscountCapConstraint[DiscountCapConstraint["MaxDiscountAmount"] = 2] = "MaxDiscountAmount";
    /**
    * The cap&#39;s MinimumFinalUnitPrice was the binding constraint.
    */
    DiscountCapConstraint[DiscountCapConstraint["MinimumFinalUnitPrice"] = 3] = "MinimumFinalUnitPrice";
    /**
    * Default value for unknown data
    */
    DiscountCapConstraint[DiscountCapConstraint["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DiscountCapConstraint || (DiscountCapConstraint = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * How a product-offer discount value is interpreted by the checkout pipeline.  Serialized as `int` on the cart-action JSON payload. The default BizWeb.NC.Base.Enumerations.DiscountMode.Percentage (0) matches the legacy payloads that carried no discount-mode field, so existing actions keep percentage behaviour with no migration. Values may only be appended (never renumbered) because the value is persisted.
 * @export
 * @enum {number}
 */
var DiscountMode;
(function (DiscountMode) {
    /**
    * The discount value is a percentage of the line&#39;s list price.
    */
    DiscountMode[DiscountMode["Percentage"] = 0] = "Percentage";
    /**
    * The discount value is a fixed amount applied per discounted unit (clamped to the unit&#39;s list price).
    */
    DiscountMode[DiscountMode["Amount"] = 1] = "Amount";
    /**
    * Default value for unknown data
    */
    DiscountMode[DiscountMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DiscountMode || (DiscountMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Identifies what an applied discount is targeting. Used by both the live cart/checkout DTO (`AppliedDiscounts.Target`, `OrdersDiscountToken.Target`) and the persisted event/ledger rows (`CouponEvent.DiscountTarget`, `PromotionPolicyEvent.DiscountTarget`, `OrderDiscount.DiscountTarget`) so downstream consumers can distinguish, e.g., a coupon that discounts shipping from one that discounts products.  Persisted as `int` on the database and serialized as `int` on the wire. The DB columns are `NOT NULL DEFAULT 0`; pre-migration rows are backfilled to BizWeb.NC.Base.Enumerations.DiscountTarget.Default automatically by the migration\'s `DEFAULT` clause. Values may only be appended (never renumbered) because the value is persisted as an integer.
 * @export
 * @enum {number}
 */
var DiscountTarget;
(function (DiscountTarget) {
    /**
    * Product / line / cart-level discount (current behavior for all legacy rows).
    */
    DiscountTarget[DiscountTarget["Default"] = 0] = "Default";
    /**
    * Discount targets the order&#39;s shipping fee.
    */
    DiscountTarget[DiscountTarget["ShippingFee"] = 1] = "ShippingFee";
    /**
    * Default value for unknown data
    */
    DiscountTarget[DiscountTarget["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(DiscountTarget || (DiscountTarget = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var EventPlace;
(function (EventPlace) {
    EventPlace[EventPlace["InPerson"] = 0] = "InPerson";
    EventPlace[EventPlace["online"] = 1] = "online";
    /**
    * Default value for unknown data
    */
    EventPlace[EventPlace["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(EventPlace || (EventPlace = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Lifecycle of an event subscription (back-in-stock \"Notify me\").
 * @export
 * @enum {number}
 */
var EventSubscriptionStatus;
(function (EventSubscriptionStatus) {
    /**
    * Guest request awaiting double opt-in confirmation (only when BackInStockSubscription_DoubleOptIn is on).
    */
    EventSubscriptionStatus[EventSubscriptionStatus["PendingConfirmation"] = 0] = "PendingConfirmation";
    /**
    * Confirmed (or registered customer, or opt-in off); waiting for the product to become purchasable.
    */
    EventSubscriptionStatus[EventSubscriptionStatus["PendingNotification"] = 1] = "PendingNotification";
    /**
    * Notification e-mail has been queued (see ).
    */
    EventSubscriptionStatus[EventSubscriptionStatus["Notified"] = 2] = "Notified";
    /**
    * Default value for unknown data
    */
    EventSubscriptionStatus[EventSubscriptionStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(EventSubscriptionStatus || (EventSubscriptionStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var FilterType;
(function (FilterType) {
    FilterType[FilterType["Category"] = 1] = "Category";
    FilterType[FilterType["Attribute"] = 2] = "Attribute";
    FilterType[FilterType["Status"] = 3] = "Status";
    FilterType[FilterType["DimensionColor"] = 4] = "DimensionColor";
    FilterType[FilterType["DimensionSize"] = 5] = "DimensionSize";
    FilterType[FilterType["Manufacturer"] = 6] = "Manufacturer";
    FilterType[FilterType["Model"] = 7] = "Model";
    FilterType[FilterType["Price"] = 8] = "Price";
    FilterType[FilterType["DiscountRates"] = 9] = "DiscountRates";
    FilterType[FilterType["Branch"] = 10] = "Branch";
    FilterType[FilterType["Feature"] = 11] = "Feature";
    FilterType[FilterType["Subtype"] = 12] = "Subtype";
    FilterType[FilterType["EventCategory"] = 13] = "EventCategory";
    FilterType[FilterType["CountryRegion"] = 14] = "CountryRegion";
    FilterType[FilterType["EventTag"] = 15] = "EventTag";
    FilterType[FilterType["Availability"] = 16] = "Availability";
    FilterType[FilterType["RatingBase5"] = 17] = "RatingBase5";
    FilterType[FilterType["Promotion"] = 18] = "Promotion";
    FilterType[FilterType["CalculatedAvailability"] = 19] = "CalculatedAvailability";
    FilterType[FilterType["Pieces"] = 20] = "Pieces";
    FilterType[FilterType["Authors"] = 21] = "Authors";
    FilterType[FilterType["Publishers"] = 22] = "Publishers";
    FilterType[FilterType["Released"] = 23] = "Released";
    FilterType[FilterType["WarehouseStock"] = 24] = "WarehouseStock";
    FilterType[FilterType["HotPrice"] = 25] = "HotPrice";
    FilterType[FilterType["DimensionCustom"] = 26] = "DimensionCustom";
    /**
    * Default value for unknown data
    */
    FilterType[FilterType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(FilterType || (FilterType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Whether an import upload adds the listed associations or removes them. Same Excel schema is used for both; the mode is chosen per upload.
 * @export
 * @enum {number}
 */
var ImportMode;
(function (ImportMode) {
    ImportMode[ImportMode["Add"] = 0] = "Add";
    ImportMode[ImportMode["Remove"] = 1] = "Remove";
    /**
    * Default value for unknown data
    */
    ImportMode[ImportMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ImportMode || (ImportMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Why a line cannot be shipped to the destination country.
 * @export
 * @enum {number}
 */
var IneligibilityReason;
(function (IneligibilityReason) {
    /**
    * The product&#39;s manufacturer is excluded for the destination country (ManufacturerCountryExclusion).
    */
    IneligibilityReason[IneligibilityReason["ManufacturerExcluded"] = 1] = "ManufacturerExcluded";
    /**
    * The product/dimension itself is not shipped to the country ().
    */
    IneligibilityReason[IneligibilityReason["NotShippableToCountry"] = 2] = "NotShippableToCountry";
    /**
    * Default value for unknown data
    */
    IneligibilityReason[IneligibilityReason["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(IneligibilityReason || (IneligibilityReason = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * A loyalty event\'s type: the values are the LoyaltyPointEventTypes rows\' ids, used by the ledger and every query.
 * @export
 * @enum {number}
 */
var LoyaltyEventType;
(function (LoyaltyEventType) {
    LoyaltyEventType[LoyaltyEventType["PendingOrderProduct"] = 1] = "PendingOrderProduct";
    LoyaltyEventType[LoyaltyEventType["Credit"] = 2] = "Credit";
    LoyaltyEventType[LoyaltyEventType["Redeem"] = 3] = "Redeem";
    LoyaltyEventType[LoyaltyEventType["Revert"] = 4] = "Revert";
    LoyaltyEventType[LoyaltyEventType["Birthday"] = 5] = "Birthday";
    LoyaltyEventType[LoyaltyEventType["Register"] = 6] = "Register";
    LoyaltyEventType[LoyaltyEventType["ForConsumption"] = 7] = "ForConsumption";
    LoyaltyEventType[LoyaltyEventType["EnterGender"] = 8] = "EnterGender";
    /**
    * Never awarded; kept because the event type row exists (the newsletter setting was removed).
    */
    LoyaltyEventType[LoyaltyEventType["Newsletter"] = 9] = "Newsletter";
    LoyaltyEventType[LoyaltyEventType["EnterBirthday"] = 10] = "EnterBirthday";
    LoyaltyEventType[LoyaltyEventType["NewAppointment"] = 11] = "NewAppointment";
    LoyaltyEventType[LoyaltyEventType["ReadBlog"] = 12] = "ReadBlog";
    LoyaltyEventType[LoyaltyEventType["ViewVideo"] = 13] = "ViewVideo";
    LoyaltyEventType[LoyaltyEventType["ReferAFriend"] = 14] = "ReferAFriend";
    LoyaltyEventType[LoyaltyEventType["AcceptReferAFriend"] = 15] = "AcceptReferAFriend";
    LoyaltyEventType[LoyaltyEventType["Review"] = 16] = "Review";
    LoyaltyEventType[LoyaltyEventType["RevertAfterEdit"] = 17] = "RevertAfterEdit";
    LoyaltyEventType[LoyaltyEventType["CancelAppointment"] = 18] = "CancelAppointment";
    /**
    * Points removed by the daily expiry run (negative): one event per customer and expiry date.
    */
    LoyaltyEventType[LoyaltyEventType["Expired"] = 19] = "Expired";
    /**
    * Points an admin added or took away by hand (PointCustomer/AdjustPoints), with the admin and a note.
    */
    LoyaltyEventType[LoyaltyEventType["ManualAdjustment"] = 20] = "ManualAdjustment";
    /**
    * Default value for unknown data
    */
    LoyaltyEventType[LoyaltyEventType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(LoyaltyEventType || (LoyaltyEventType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Why points of an order were taken back or given back (Revert rows).
 * @export
 * @enum {number}
 */
var LoyaltyHistoryReason;
(function (LoyaltyHistoryReason) {
    LoyaltyHistoryReason[LoyaltyHistoryReason["Cancelled"] = 1] = "Cancelled";
    LoyaltyHistoryReason[LoyaltyHistoryReason["Returned"] = 2] = "Returned";
    LoyaltyHistoryReason[LoyaltyHistoryReason["Refunded"] = 3] = "Refunded";
    LoyaltyHistoryReason[LoyaltyHistoryReason["Adjusted"] = 4] = "Adjusted";
    /**
    * The points an order used, given back (it was cancelled, returned or refunded).
    */
    LoyaltyHistoryReason[LoyaltyHistoryReason["PointsReturned"] = 5] = "PointsReturned";
    /**
    * Default value for unknown data
    */
    LoyaltyHistoryReason[LoyaltyHistoryReason["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(LoyaltyHistoryReason || (LoyaltyHistoryReason = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var LoyaltyHistoryStatus;
(function (LoyaltyHistoryStatus) {
    /**
    * An order not paid yet.
    */
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Pending"] = 1] = "Pending";
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Credited"] = 2] = "Credited";
    /**
    * Held by an order not paid yet.
    */
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Reserved"] = 3] = "Reserved";
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Used"] = 4] = "Used";
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Reversed"] = 5] = "Reversed";
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["Expired"] = 6] = "Expired";
    /**
    * Default value for unknown data
    */
    LoyaltyHistoryStatus[LoyaltyHistoryStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(LoyaltyHistoryStatus || (LoyaltyHistoryStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The value of an event type row\'s BizWeb.NC.Data.Domain.Customers.LoyaltyPointEventType.EventType column (shown to the admins as e_tp). It is not the event type\'s id: the ledger and every query use `BizWeb.NC.Types.LoyaltyEventType`, whose values are the rows\' ids (1-based; the first four values here are 0-based, so the two only agree from Birthday = 5 on).
 * @export
 * @enum {number}
 */
var LoyaltyPointsEventCode;
(function (LoyaltyPointsEventCode) {
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["PendingOrderProduct"] = 0] = "PendingOrderProduct";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Credit"] = 1] = "Credit";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Redeem"] = 2] = "Redeem";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Revert"] = 3] = "Revert";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Custom"] = 4] = "Custom";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Birthday"] = 5] = "Birthday";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Register"] = 6] = "Register";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["ForConsumption"] = 7] = "ForConsumption";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["EnterGender"] = 8] = "EnterGender";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Newsletter"] = 9] = "Newsletter";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["EnterBirthday"] = 10] = "EnterBirthday";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["NewAppointment"] = 11] = "NewAppointment";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["ReadBlog"] = 12] = "ReadBlog";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["ViewVideo"] = 13] = "ViewVideo";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["ReferAFriend"] = 14] = "ReferAFriend";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["AcceptReferAFriend"] = 15] = "AcceptReferAFriend";
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["Review"] = 16] = "Review";
    /**
    * Default value for unknown data
    */
    LoyaltyPointsEventCode[LoyaltyPointsEventCode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(LoyaltyPointsEventCode || (LoyaltyPointsEventCode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Which real identity an BizWeb.NC.Data.Domain.Ai.McpKey resolves to. BizWeb.NC.Data.Domain.Ai.McpKeyIdentityContext.FrontEnd is the enum default (0) so a defaulted/unset context is the least-privileged one. See docs/ai/02a-principal-linkage.md §2.1.
 * @export
 * @enum {number}
 */
var McpKeyIdentityContext;
(function (McpKeyIdentityContext) {
    McpKeyIdentityContext[McpKeyIdentityContext["FrontEnd"] = 0] = "FrontEnd";
    McpKeyIdentityContext[McpKeyIdentityContext["Admin"] = 1] = "Admin";
    /**
    * Default value for unknown data
    */
    McpKeyIdentityContext[McpKeyIdentityContext["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(McpKeyIdentityContext || (McpKeyIdentityContext = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var MethodOfPurchase;
(function (MethodOfPurchase) {
    MethodOfPurchase[MethodOfPurchase["Online"] = 0] = "Online";
    MethodOfPurchase[MethodOfPurchase["Phone"] = 1] = "Phone";
    MethodOfPurchase[MethodOfPurchase["App"] = 2] = "App";
    /**
    * Default value for unknown data
    */
    MethodOfPurchase[MethodOfPurchase["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(MethodOfPurchase || (MethodOfPurchase = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var NewsEntriesSource;
(function (NewsEntriesSource) {
    NewsEntriesSource[NewsEntriesSource["InternalUrl"] = 0] = "InternalUrl";
    NewsEntriesSource[NewsEntriesSource["ExternalUrl"] = 1] = "ExternalUrl";
    /**
    * Default value for unknown data
    */
    NewsEntriesSource[NewsEntriesSource["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(NewsEntriesSource || (NewsEntriesSource = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * How an article renders its linked products on the storefront. Undefined is an EF in-memory sentinel only (never persisted); the column default is Classic.
 * @export
 * @enum {number}
 */
var NewsEntryProductsDisplayMode;
(function (NewsEntryProductsDisplayMode) {
    NewsEntryProductsDisplayMode[NewsEntryProductsDisplayMode["Classic"] = 0] = "Classic";
    NewsEntryProductsDisplayMode[NewsEntryProductsDisplayMode["ProductPlp"] = 1] = "ProductPlp";
    NewsEntryProductsDisplayMode[NewsEntryProductsDisplayMode["Undefined"] = -1] = "Undefined";
    /**
    * Default value for unknown data
    */
    NewsEntryProductsDisplayMode[NewsEntryProductsDisplayMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(NewsEntryProductsDisplayMode || (NewsEntryProductsDisplayMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Editorial visibility state (BW-8339, from H&B VA-10461), independent of the inherited binary `MasterEntity.IsVisible` and of the schedule dates (all apply). Published = listed and reachable; Draft = excluded everywhere on the storefront (direct URL 404); Hidden = left out of listings but reachable by direct URL.
 * @export
 * @enum {number}
 */
var NewsEntryVisibility;
(function (NewsEntryVisibility) {
    NewsEntryVisibility[NewsEntryVisibility["Published"] = 0] = "Published";
    NewsEntryVisibility[NewsEntryVisibility["Draft"] = 1] = "Draft";
    NewsEntryVisibility[NewsEntryVisibility["Hidden"] = 2] = "Hidden";
    /**
    * Default value for unknown data
    */
    NewsEntryVisibility[NewsEntryVisibility["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(NewsEntryVisibility || (NewsEntryVisibility = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var NotificationPersonsEntityType;
(function (NotificationPersonsEntityType) {
    NotificationPersonsEntityType[NotificationPersonsEntityType["Inspector"] = 1] = "Inspector";
    NotificationPersonsEntityType[NotificationPersonsEntityType["SalesPerson"] = 2] = "SalesPerson";
    NotificationPersonsEntityType[NotificationPersonsEntityType["Customer"] = 3] = "Customer";
    NotificationPersonsEntityType[NotificationPersonsEntityType["Employee"] = 4] = "Employee";
    /**
    * Default value for unknown data
    */
    NotificationPersonsEntityType[NotificationPersonsEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(NotificationPersonsEntityType || (NotificationPersonsEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var OnlinePaymentType;
(function (OnlinePaymentType) {
    OnlinePaymentType[OnlinePaymentType["None"] = 0] = "None";
    OnlinePaymentType[OnlinePaymentType["Paypal"] = 1] = "Paypal";
    OnlinePaymentType[OnlinePaymentType["WinBank"] = 2] = "WinBank";
    OnlinePaymentType[OnlinePaymentType["Viva"] = 3] = "Viva";
    OnlinePaymentType[OnlinePaymentType["Alpha"] = 4] = "Alpha";
    OnlinePaymentType[OnlinePaymentType["Klarna"] = 5] = "Klarna";
    OnlinePaymentType[OnlinePaymentType["Eurobank"] = 6] = "Eurobank";
    OnlinePaymentType[OnlinePaymentType["Iris"] = 7] = "Iris";
    OnlinePaymentType[OnlinePaymentType["JccPayment"] = 8] = "JccPayment";
    OnlinePaymentType[OnlinePaymentType["XPay"] = 9] = "XPay";
    /**
    * Default value for unknown data
    */
    OnlinePaymentType[OnlinePaymentType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(OnlinePaymentType || (OnlinePaymentType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Pending"] = 0] = "Pending";
    OrderStatus[OrderStatus["Processing"] = 1] = "Processing";
    OrderStatus[OrderStatus["InDelivery"] = 2] = "InDelivery";
    OrderStatus[OrderStatus["Completed"] = 3] = "Completed";
    OrderStatus[OrderStatus["PartiallyDelivered"] = 4] = "PartiallyDelivered";
    OrderStatus[OrderStatus["NotDelivered"] = 5] = "NotDelivered";
    OrderStatus[OrderStatus["CheckingStock"] = 6] = "CheckingStock";
    OrderStatus[OrderStatus["Refund"] = 7] = "Refund";
    OrderStatus[OrderStatus["PartiallyReturned"] = 8] = "PartiallyReturned";
    OrderStatus[OrderStatus["Returned"] = 9] = "Returned";
    OrderStatus[OrderStatus["Invoiced"] = 10] = "Invoiced";
    OrderStatus[OrderStatus["ReadyForPickup"] = 11] = "ReadyForPickup";
    OrderStatus[OrderStatus["NA"] = -10] = "NA";
    OrderStatus[OrderStatus["Cancelled"] = -1] = "Cancelled";
    /**
    * Default value for unknown data
    */
    OrderStatus[OrderStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(OrderStatus || (OrderStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var OrderWithdrawalRequestStatus;
(function (OrderWithdrawalRequestStatus) {
    OrderWithdrawalRequestStatus[OrderWithdrawalRequestStatus["Pending"] = 0] = "Pending";
    OrderWithdrawalRequestStatus[OrderWithdrawalRequestStatus["Approved"] = 1] = "Approved";
    OrderWithdrawalRequestStatus[OrderWithdrawalRequestStatus["Rejected"] = 2] = "Rejected";
    OrderWithdrawalRequestStatus[OrderWithdrawalRequestStatus["Completed"] = 3] = "Completed";
    /**
    * Default value for unknown data
    */
    OrderWithdrawalRequestStatus[OrderWithdrawalRequestStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(OrderWithdrawalRequestStatus || (OrderWithdrawalRequestStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var PointStatus;
(function (PointStatus) {
    PointStatus[PointStatus["ApprovedPoints"] = 1] = "ApprovedPoints";
    PointStatus[PointStatus["PendingPoints"] = 2] = "PendingPoints";
    /**
    * Points held by an order saved but not placed yet (a redemption awaiting its payment).
    */
    PointStatus[PointStatus["ReservedPoints"] = 3] = "ReservedPoints";
    /**
    * Default value for unknown data
    */
    PointStatus[PointStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(PointStatus || (PointStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Καθορίζει αν μια τιμή περιλαμβάνει ή όχι τον ΦΠΑ
 * @export
 * @enum {number}
 */
var PriceTaxMode;
(function (PriceTaxMode) {
    /**
    * Η τιμή είναι πριν την εφαρμογή του ΦΠΑ
    */
    PriceTaxMode[PriceTaxMode["BeforeTaxes"] = 0] = "BeforeTaxes";
    /**
    * Η τιμή είναι μετά την εφαρμογή του ΦΠΑ
    */
    PriceTaxMode[PriceTaxMode["AfterTaxes"] = 1] = "AfterTaxes";
    /**
    * Default value for unknown data
    */
    PriceTaxMode[PriceTaxMode["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(PriceTaxMode || (PriceTaxMode = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Controls how a fixed-amount coupon with product/category targeting should be applied. This setting is relevant only for coupons that target specific products or categories. Non-targeted coupons do not use this setting.
 * @export
 * @enum {number}
 */
var ProductCouponApplicationScope;
(function (ProductCouponApplicationScope) {
    /**
    * The coupon is applied to matching cart items as a line coupon.
    */
    ProductCouponApplicationScope[ProductCouponApplicationScope["Line"] = 0] = "Line";
    /**
    * The coupon is applied once to the cart total after at least one matching targeted item
            is present in the cart.
    */
    ProductCouponApplicationScope[ProductCouponApplicationScope["Cart"] = 1] = "Cart";
    /**
    * Default value for unknown data
    */
    ProductCouponApplicationScope[ProductCouponApplicationScope["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ProductCouponApplicationScope || (ProductCouponApplicationScope = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ProductSortType;
(function (ProductSortType) {
    ProductSortType[ProductSortType["Default"] = 0] = "Default";
    ProductSortType[ProductSortType["PriceDescending"] = 1] = "PriceDescending";
    ProductSortType[ProductSortType["PriceAscending"] = 2] = "PriceAscending";
    ProductSortType[ProductSortType["NameDescending"] = 3] = "NameDescending";
    ProductSortType[ProductSortType["NameAscending"] = 4] = "NameAscending";
    ProductSortType[ProductSortType["CreateDateDescending"] = 5] = "CreateDateDescending";
    ProductSortType[ProductSortType["CreateDateAscending"] = 6] = "CreateDateAscending";
    ProductSortType[ProductSortType["QuantityDescending"] = 7] = "QuantityDescending";
    ProductSortType[ProductSortType["Bestseller"] = 8] = "Bestseller";
    ProductSortType[ProductSortType["ReleaseDateDescending"] = 9] = "ReleaseDateDescending";
    ProductSortType[ProductSortType["ReleaseDateAscending"] = 10] = "ReleaseDateAscending";
    ProductSortType[ProductSortType["DiscountDescending"] = 11] = "DiscountDescending";
    ProductSortType[ProductSortType["RatingDescending"] = 12] = "RatingDescending";
    /**
    * Default value for unknown data
    */
    ProductSortType[ProductSortType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ProductSortType || (ProductSortType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Τύπος των promotion policies.
 * @export
 * @enum {number}
 */
var PromotionPolicyTypes;
(function (PromotionPolicyTypes) {
    /**
    * Αξιακή εμπορική πολιτική (πχ -30€)
    */
    PromotionPolicyTypes[PromotionPolicyTypes["FixedAmount"] = 1] = "FixedAmount";
    /**
    * Ποσοστιαία εμπορική πολιτική (πχ -10%)
    */
    PromotionPolicyTypes[PromotionPolicyTypes["Percentage"] = 2] = "Percentage";
    /**
    * Ποσοστιαία εμπορική πολιτική τύπου X+Y (Buy One Get One type)
    */
    PromotionPolicyTypes[PromotionPolicyTypes["Bogo"] = 3] = "Bogo";
    /**
    * Προσαρμοσμένη εμπορική πολιτική. Οι συνθήκες εφαρμογής της πολιτικής, καθώς και οι ενέργειες που θα πρέπει να εκτελεστούν, καθορίζονται από τον χρήστη δυναμικά.
    */
    PromotionPolicyTypes[PromotionPolicyTypes["Customized"] = 4] = "Customized";
    /**
    * Default value for unknown data
    */
    PromotionPolicyTypes[PromotionPolicyTypes["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(PromotionPolicyTypes || (PromotionPolicyTypes = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ReceiptType;
(function (ReceiptType) {
    ReceiptType[ReceiptType["Retail"] = 0] = "Retail";
    ReceiptType[ReceiptType["Invoice"] = 1] = "Invoice";
    /**
    * Default value for unknown data
    */
    ReceiptType[ReceiptType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReceiptType || (ReceiptType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Where a referred customer stands (BW-8460).
 * @export
 * @enum {number}
 */
var ReferralStatus;
(function (ReferralStatus) {
    /**
    * Registered with the code; no reward yet.
    */
    ReferralStatus[ReferralStatus["Joined"] = 0] = "Joined";
    /**
    * A qualifying order earned the referral rewards.
    */
    ReferralStatus[ReferralStatus["Rewarded"] = 1] = "Rewarded";
    /**
    * The rewards were reversed: the order that earned them was cancelled or refunded.
    */
    ReferralStatus[ReferralStatus["Reversed"] = 2] = "Reversed";
    /**
    * Default value for unknown data
    */
    ReferralStatus[ReferralStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReferralStatus || (ReferralStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Πώς εκτελέστηκε η επιστροφή χρημάτων — <b>εκτός πλατφόρμας</b>, από τον διαχειριστή (Α-29). Ο πυρήνας καταγράφει· δεν κινεί ποτέ χρήματα (Δ-10).
 * @export
 * @enum {number}
 */
var RefundExecutionMethod;
(function (RefundExecutionMethod) {
    RefundExecutionMethod[RefundExecutionMethod["NotExecuted"] = 0] = "NotExecuted";
    RefundExecutionMethod[RefundExecutionMethod["BankTransfer"] = 1] = "BankTransfer";
    RefundExecutionMethod[RefundExecutionMethod["PaymentProviderReversal"] = 2] = "PaymentProviderReversal";
    RefundExecutionMethod[RefundExecutionMethod["OriginalPaymentInstrument"] = 3] = "OriginalPaymentInstrument";
    RefundExecutionMethod[RefundExecutionMethod["CashInStore"] = 4] = "CashInStore";
    /**
    * Πίστωση με κουπόνι, για . Το κουπόνι δημιουργείται
            χειροκίνητα από τον διαχειριστή — η πλατφόρμα δεν παράγει κανένα — και εδώ καταγράφεται ότι
            δόθηκε. Το όνομα του μέλους μένει GiftCard επειδή η τιμή 5 είναι αποθηκευμένη και εκτεθειμένη
            στον generated client· στο back office το μέσο λέγεται «κουπόνι».
    */
    RefundExecutionMethod[RefundExecutionMethod["GiftCard"] = 5] = "GiftCard";
    /**
    * Default value for unknown data
    */
    RefundExecutionMethod[RefundExecutionMethod["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(RefundExecutionMethod || (RefundExecutionMethod = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Τι ζητά ο πελάτης για το συγκεκριμένο τεμάχιο. Ζει στη γραμμή, όχι στην κεφαλίδα, ώστε ένα αίτημα να μπορεί να συνδυάζει ενέργειες.
 * @export
 * @enum {number}
 */
var ReturnDesiredAction;
(function (ReturnDesiredAction) {
    ReturnDesiredAction[ReturnDesiredAction["None"] = 0] = "None";
    ReturnDesiredAction[ReturnDesiredAction["Refund"] = 1] = "Refund";
    ReturnDesiredAction[ReturnDesiredAction["Replacement"] = 2] = "Replacement";
    /**
    * Πίστωση με κουπόνι. Ενεργή μόνο με Returns.CreditEnabled (Α-03).
    */
    ReturnDesiredAction[ReturnDesiredAction["Credit"] = 3] = "Credit";
    /**
    * Default value for unknown data
    */
    ReturnDesiredAction[ReturnDesiredAction["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnDesiredAction || (ReturnDesiredAction = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Κατάσταση ανά τεμάχιο. Ο μηχανισμός μεταβάσεων ορίζεται στην `ReturnStatusTransitions`.
 * @export
 * @enum {number}
 */
var ReturnItemStatus;
(function (ReturnItemStatus) {
    ReturnItemStatus[ReturnItemStatus["New"] = 1] = "New";
    ReturnItemStatus[ReturnItemStatus["UnderReview"] = 2] = "UnderReview";
    ReturnItemStatus[ReturnItemStatus["Approved"] = 3] = "Approved";
    ReturnItemStatus[ReturnItemStatus["AwaitingProduct"] = 4] = "AwaitingProduct";
    ReturnItemStatus[ReturnItemStatus["InProgress"] = 5] = "InProgress";
    ReturnItemStatus[ReturnItemStatus["Completed"] = 6] = "Completed";
    ReturnItemStatus[ReturnItemStatus["Rejected"] = 7] = "Rejected";
    /**
    * Default value for unknown data
    */
    ReturnItemStatus[ReturnItemStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnItemStatus || (ReturnItemStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Τρόποι επιστροφής. Χρησιμοποιείται και ως bitmask (`Returns.EnabledMethods`, `ReturnPolicy.BlockedMethods`), οπότε οι τιμές είναι δυνάμεις του δύο.
 * @export
 * @enum {number}
 */
var ReturnMethod;
(function (ReturnMethod) {
    ReturnMethod[ReturnMethod["None"] = 0] = "None";
    ReturnMethod[ReturnMethod["CourierPickup"] = 1] = "CourierPickup";
    ReturnMethod[ReturnMethod["LockerDropOff"] = 2] = "LockerDropOff";
    ReturnMethod[ReturnMethod["FreightCarrier"] = 4] = "FreightCarrier";
    /**
    * Default value for unknown data
    */
    ReturnMethod[ReturnMethod["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnMethod || (ReturnMethod = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
 * @export
 * @enum {number}
 */
var ReturnPolicyEntityType;
(function (ReturnPolicyEntityType) {
    ReturnPolicyEntityType[ReturnPolicyEntityType["Product"] = 1] = "Product";
    ReturnPolicyEntityType[ReturnPolicyEntityType["Category"] = 2] = "Category";
    /**
    * Default value for unknown data
    */
    ReturnPolicyEntityType[ReturnPolicyEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnPolicyEntityType || (ReturnPolicyEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Οι εννέα λόγοι επιστροφής του πυρήνα (Α-02). Οι τιμές δεν επαναριθμούνται ποτέ: το σημείο επέκτασης ταξινομίας (`IReturnTaxonomyProvider`) προσθέτει, κρύβει ή μετονομάζει λόγους χωρίς αλλαγή σχήματος.
 * @export
 * @enum {number}
 */
var ReturnReason;
(function (ReturnReason) {
    ReturnReason[ReturnReason["None"] = 0] = "None";
    /**
    * Υπαναχώρηση. Ο μόνος λόγος που δεν απαιτεί σχόλιο και φωτογραφίες.
    */
    ReturnReason[ReturnReason["ChangedMind"] = 1] = "ChangedMind";
    ReturnReason[ReturnReason["PoorCondition"] = 2] = "PoorCondition";
    ReturnReason[ReturnReason["Defective"] = 3] = "Defective";
    ReturnReason[ReturnReason["WrongProduct"] = 4] = "WrongProduct";
    ReturnReason[ReturnReason["MissingPart"] = 5] = "MissingPart";
    ReturnReason[ReturnReason["FewerPieces"] = 6] = "FewerPieces";
    ReturnReason[ReturnReason["MorePieces"] = 7] = "MorePieces";
    ReturnReason[ReturnReason["WrongColour"] = 8] = "WrongColour";
    ReturnReason[ReturnReason["WrongSize"] = 9] = "WrongSize";
    /**
    * Default value for unknown data
    */
    ReturnReason[ReturnReason["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnReason || (ReturnReason = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Ο τύπος τιμής μιας ρύθμισης, ώστε το διαχειριστικό να δείξει το σωστό control και ο server να απορρίψει τιμή που δεν διαβάζεται.
 * @export
 * @enum {number}
 */
var ReturnSettingValueKind;
(function (ReturnSettingValueKind) {
    ReturnSettingValueKind[ReturnSettingValueKind["Boolean"] = 1] = "Boolean";
    ReturnSettingValueKind[ReturnSettingValueKind["Integer"] = 2] = "Integer";
    /**
    * Κείμενα χωρισμένα με κόμμα.
    */
    ReturnSettingValueKind[ReturnSettingValueKind["StringList"] = 3] = "StringList";
    /**
    * Ακέραιοι χωρισμένοι με κόμμα.
    */
    ReturnSettingValueKind[ReturnSettingValueKind["IntegerList"] = 4] = "IntegerList";
    /**
    * delivery ή purchase.
    */
    ReturnSettingValueKind[ReturnSettingValueKind["WindowAnchor"] = 5] = "WindowAnchor";
    /**
    * Bitmask , ως ονόματα ή ως αριθμός.
    */
    ReturnSettingValueKind[ReturnSettingValueKind["MethodFlags"] = 6] = "MethodFlags";
    /**
    * Default value for unknown data
    */
    ReturnSettingValueKind[ReturnSettingValueKind["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnSettingValueKind || (ReturnSettingValueKind = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Γιατί απορρίφθηκε μια μετάβαση κατάστασης.
 * @export
 * @enum {number}
 */
var ReturnTransitionRejection;
(function (ReturnTransitionRejection) {
    ReturnTransitionRejection[ReturnTransitionRejection["None"] = 0] = "None";
    /**
    * Η μετάβαση δεν υπάρχει στον πίνακα της ενότητας 6.
    */
    ReturnTransitionRejection[ReturnTransitionRejection["IllegalTransition"] = 1] = "IllegalTransition";
    /**
    * (Α-29 / Δ-10) «Ολοκληρώθηκε» σε τεμάχιο επιστροφής χρημάτων ή πίστωσης χωρίς καταγεγραμμένη εκτέλεση.
    */
    ReturnTransitionRejection[ReturnTransitionRejection["RefundExecutionNotRecorded"] = 2] = "RefundExecutionNotRecorded";
    /**
    * (Α-30 / Δ-11) «Ολοκληρώθηκε» σε τεμάχιο αντικατάστασης χωρίς καταγεγραμμένη αποστολή.
    */
    ReturnTransitionRejection[ReturnTransitionRejection["ReplacementDispatchNotRecorded"] = 3] = "ReplacementDispatchNotRecorded";
    /**
    * «Απορρίφθηκε» σε τεμάχιο που έχει ήδη στο αρχείο την εγγραφή της επιθυμίας του — πληρωμένο ή σταλμένο. Η
            απόρριψη ελευθερώνει το τεμάχιο για νέο αίτημα, οπότε θα πληρωνόταν ή θα στελνόταν δεύτερη φορά.
    */
    ReturnTransitionRejection[ReturnTransitionRejection["SettlementAlreadyRecorded"] = 4] = "SettlementAlreadyRecorded";
    /**
    * Default value for unknown data
    */
    ReturnTransitionRejection[ReturnTransitionRejection["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReturnTransitionRejection || (ReturnTransitionRejection = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ReviewReportReason;
(function (ReviewReportReason) {
    ReviewReportReason[ReviewReportReason["Spam"] = 1] = "Spam";
    ReviewReportReason[ReviewReportReason["Offensive"] = 2] = "Offensive";
    ReviewReportReason[ReviewReportReason["OffTopic"] = 3] = "OffTopic";
    ReviewReportReason[ReviewReportReason["Misleading"] = 4] = "Misleading";
    ReviewReportReason[ReviewReportReason["Other"] = 5] = "Other";
    /**
    * Default value for unknown data
    */
    ReviewReportReason[ReviewReportReason["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReviewReportReason || (ReviewReportReason = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus[ReviewStatus["Pending"] = 0] = "Pending";
    ReviewStatus[ReviewStatus["Accepted"] = 1] = "Accepted";
    ReviewStatus[ReviewStatus["Declined"] = 2] = "Declined";
    ReviewStatus[ReviewStatus["Revisioned"] = 3] = "Revisioned";
    /**
    * Default value for unknown data
    */
    ReviewStatus[ReviewStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ReviewStatus || (ReviewStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var SettingValueType;
(function (SettingValueType) {
    /**
    * Unknown type
    */
    SettingValueType[SettingValueType["Unknown"] = 0] = "Unknown";
    /**
    * Integer
    */
    SettingValueType[SettingValueType["Integer"] = 1] = "Integer";
    /**
    * Decimal
    */
    SettingValueType[SettingValueType["Decimal"] = 2] = "Decimal";
    /**
    * Boolean
    */
    SettingValueType[SettingValueType["Boolean"] = 3] = "Boolean";
    /**
    * Short String (up to 100 chars)
    */
    SettingValueType[SettingValueType["String"] = 4] = "String";
    /**
    * Long String (MAX)
    */
    SettingValueType[SettingValueType["Text"] = 5] = "Text";
    /**
    * Date (without time)
    */
    SettingValueType[SettingValueType["Date"] = 6] = "Date";
    /**
    * Time (within a day)
    */
    SettingValueType[SettingValueType["Time"] = 7] = "Time";
    /**
    * Timespan (duration).
    */
    SettingValueType[SettingValueType["TimeSpan"] = 8] = "TimeSpan";
    /**
    * Date and time
    */
    SettingValueType[SettingValueType["DateTime"] = 9] = "DateTime";
    /**
    * Date and time with offset
    */
    SettingValueType[SettingValueType["DateTimeOffset"] = 10] = "DateTimeOffset";
    /**
    * Unique identifier
    */
    SettingValueType[SettingValueType["Guid"] = 11] = "Guid";
    /**
    * Binary data
    */
    SettingValueType[SettingValueType["ByteArray"] = 12] = "ByteArray";
    /**
    * Default value for unknown data
    */
    SettingValueType[SettingValueType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(SettingValueType || (SettingValueType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var SmsNotificationChannel;
(function (SmsNotificationChannel) {
    /**
    * SMS channel
    */
    SmsNotificationChannel[SmsNotificationChannel["Sms"] = 0] = "Sms";
    /**
    * Viber channel
    */
    SmsNotificationChannel[SmsNotificationChannel["Viber"] = 1] = "Viber";
    /**
    * Default value for unknown data
    */
    SmsNotificationChannel[SmsNotificationChannel["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(SmsNotificationChannel || (SmsNotificationChannel = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Status ΦΠΑ του πελάτη
 * @export
 * @enum {number}
 */
var TaxStatus;
(function (TaxStatus) {
    /**
    * Κανονικό
    */
    TaxStatus[TaxStatus["Normal"] = 0] = "Normal";
    /**
    * Μειωμένο
    */
    TaxStatus[TaxStatus["Reduced"] = 1] = "Reduced";
    /**
    * Απαλλαγή (Το διαφοροποιούμε από το 0% που αφορά προϊόντα). Ισχύει σε περιπτώσεις όπως (ορισμένες) πωλήσεις σε εξωτερικό, ή πωλήσεις με αποφορολόγηση.
    */
    TaxStatus[TaxStatus["Exempt"] = 2] = "Exempt";
    /**
    * Default value for unknown data
    */
    TaxStatus[TaxStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(TaxStatus || (TaxStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *  Η βαθμίδα ΦΠΑ του προϊόντος  Τα ποσοστά ΦΠΑ για κάθε βαθμίδα καθορίζονται ανάλογα το καθεστώς ΦΠΑ στο οποίο εμπίπτει η πώληση <list type=\"table\">   <listheader>     <term>Βαθμίδα</term>     <term>Κανονικό Καθεστώς</term>     <term>Μειωμένο Καθεστώς</term>     <term>Καθεστώς Απαλλαγής</term>   </listheader>   <item>     <term>Normal</term>     <term>24%</term>     <term>17%</term>     <term>0%</term>   </item>   <item>     <term>Reduced</term>     <term>13%</term>     <term>9%</term>     <term>0%</term>   </item>   <item>     <term>ExtraReduced</term>     <term>6%</term>     <term>4%</term>     <term>0%</term>   </item>   <item>     <term>Zero</term>     <term>0%</term>     <term>0%</term>     <term>0%</term>   </item> </list>
 * @export
 * @enum {number}
 */
var TaxType;
(function (TaxType) {
    /**
    * 24% Κανονικό, 17% Μειωμένο
    */
    TaxType[TaxType["Normal"] = 0] = "Normal";
    /**
    * 13% Κανονικό, 9% Μειωμένο
    */
    TaxType[TaxType["Reduced"] = 1] = "Reduced";
    /**
    * 6% Κανονικό, 4% Μειωμένο
    */
    TaxType[TaxType["ExtraReduced"] = 2] = "ExtraReduced";
    /**
    * 0% ΦΠΑ
    */
    TaxType[TaxType["Zero"] = 3] = "Zero";
    /**
    * Default value for unknown data
    */
    TaxType[TaxType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(TaxType || (TaxType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Καθορίζει τον τύπο ενός string template (πχ ενός email template)
 * @export
 * @enum {number}
 */
var TemplateEngineType;
(function (TemplateEngineType) {
    /**
    * Το default template του BizWeb (string.Replace στους placeholders)
    */
    TemplateEngineType[TemplateEngineType["Bizweb"] = 0] = "Bizweb";
    /**
    * Handlebars template (λειτουργεί με την βιβλιοθήκη Handlebars.net)
    */
    TemplateEngineType[TemplateEngineType["Handlebars"] = 1] = "Handlebars";
    /**
    * Default value for unknown data
    */
    TemplateEngineType[TemplateEngineType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(TemplateEngineType || (TemplateEngineType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var UserLinkedEntityType;
(function (UserLinkedEntityType) {
    UserLinkedEntityType[UserLinkedEntityType["Empty"] = 0] = "Empty";
    UserLinkedEntityType[UserLinkedEntityType["Inspector"] = 1] = "Inspector";
    UserLinkedEntityType[UserLinkedEntityType["SalesPerson"] = 2] = "SalesPerson";
    UserLinkedEntityType[UserLinkedEntityType["Customer"] = 3] = "Customer";
    /**
    * Default value for unknown data
    */
    UserLinkedEntityType[UserLinkedEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(UserLinkedEntityType || (UserLinkedEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ValueDataType;
(function (ValueDataType) {
    ValueDataType[ValueDataType["Text"] = 1] = "Text";
    ValueDataType[ValueDataType["Integer"] = 2] = "Integer";
    ValueDataType[ValueDataType["Decimal"] = 3] = "Decimal";
    ValueDataType[ValueDataType["Boolean"] = 4] = "Boolean";
    ValueDataType[ValueDataType["DateTime"] = 5] = "DateTime";
    /**
    * Default value for unknown data
    */
    ValueDataType[ValueDataType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ValueDataType || (ValueDataType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var BooleanFilter;
(function (BooleanFilter) {
    BooleanFilter[BooleanFilter["All"] = 0] = "All";
    BooleanFilter[BooleanFilter["True"] = 1] = "True";
    BooleanFilter[BooleanFilter["False"] = 2] = "False";
    /**
    * Default value for unknown data
    */
    BooleanFilter[BooleanFilter["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(BooleanFilter || (BooleanFilter = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ProductType;
(function (ProductType) {
    ProductType[ProductType["Product"] = 0] = "Product";
    ProductType[ProductType["GiftCard"] = 1] = "GiftCard";
    ProductType[ProductType["Grouped"] = 2] = "Grouped";
    ProductType[ProductType["Bundle"] = 3] = "Bundle";
    ProductType[ProductType["Giftbox"] = 4] = "Giftbox";
    ProductType[ProductType["Custom"] = 5] = "Custom";
    ProductType[ProductType["NotInitialize"] = 999] = "NotInitialize";
    /**
    * Default value for unknown data
    */
    ProductType[ProductType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ProductType || (ProductType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ShipmentTrackingAvailability;
(function (ShipmentTrackingAvailability) {
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["Available"] = 0] = "Available";
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["NotAvailable"] = 1] = "NotAvailable";
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["ProviderNotMapped"] = 2] = "ProviderNotMapped";
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["ProviderNotRegistered"] = 3] = "ProviderNotRegistered";
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["Unavailable"] = 4] = "Unavailable";
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["NoHistory"] = 5] = "NoHistory";
    /**
    * Default value for unknown data
    */
    ShipmentTrackingAvailability[ShipmentTrackingAvailability["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ShipmentTrackingAvailability || (ShipmentTrackingAvailability = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var ShipmentTrackingStatus;
(function (ShipmentTrackingStatus) {
    ShipmentTrackingStatus[ShipmentTrackingStatus["Unknown"] = 0] = "Unknown";
    ShipmentTrackingStatus[ShipmentTrackingStatus["Pending"] = 1] = "Pending";
    ShipmentTrackingStatus[ShipmentTrackingStatus["InfoReceived"] = 2] = "InfoReceived";
    ShipmentTrackingStatus[ShipmentTrackingStatus["InTransit"] = 3] = "InTransit";
    ShipmentTrackingStatus[ShipmentTrackingStatus["AtFacility"] = 4] = "AtFacility";
    ShipmentTrackingStatus[ShipmentTrackingStatus["OutForDelivery"] = 5] = "OutForDelivery";
    ShipmentTrackingStatus[ShipmentTrackingStatus["DeliveryAttempted"] = 6] = "DeliveryAttempted";
    ShipmentTrackingStatus[ShipmentTrackingStatus["DeliveryIssue"] = 7] = "DeliveryIssue";
    ShipmentTrackingStatus[ShipmentTrackingStatus["ReadyForPickup"] = 8] = "ReadyForPickup";
    ShipmentTrackingStatus[ShipmentTrackingStatus["Delivered"] = 9] = "Delivered";
    ShipmentTrackingStatus[ShipmentTrackingStatus["Exception"] = 10] = "Exception";
    ShipmentTrackingStatus[ShipmentTrackingStatus["Returned"] = 11] = "Returned";
    ShipmentTrackingStatus[ShipmentTrackingStatus["Cancelled"] = 12] = "Cancelled";
    /**
    * Default value for unknown data
    */
    ShipmentTrackingStatus[ShipmentTrackingStatus["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(ShipmentTrackingStatus || (ShipmentTrackingStatus = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var UrlEntityType;
(function (UrlEntityType) {
    /**
    * Url Prefix: &quot;/pages&quot;
    */
    UrlEntityType[UrlEntityType["CMSPage"] = 1] = "CMSPage";
    /**
    * Url Prefix: &quot;/categories&quot;
    */
    UrlEntityType[UrlEntityType["Category"] = 2] = "Category";
    /**
    * Url Prefix: &quot;/products&quot;
    */
    UrlEntityType[UrlEntityType["Product"] = 3] = "Product";
    /**
    * Url Prefix: &quot;/status&quot;
    */
    UrlEntityType[UrlEntityType["Status"] = 4] = "Status";
    /**
    * Url Prefix: &quot;/blogPost&quot;
    */
    UrlEntityType[UrlEntityType["NewsEntry"] = 5] = "NewsEntry";
    /**
    * Url Prefix: &quot;/blog&quot;
    */
    UrlEntityType[UrlEntityType["NewsCategory"] = 6] = "NewsCategory";
    /**
    * Url Prefix: &quot;/brands&quot;
    */
    UrlEntityType[UrlEntityType["Manufacturer"] = 7] = "Manufacturer";
    /**
    * Url Prefix: &quot;/event&quot;
    */
    UrlEntityType[UrlEntityType["Event"] = 8] = "Event";
    /**
    * Url Prefix: &quot;/videos&quot;
    */
    UrlEntityType[UrlEntityType["VideoCategory"] = 9] = "VideoCategory";
    /**
    * Url Prefix: &quot;/events&quot;
    */
    UrlEntityType[UrlEntityType["EventCategory"] = 10] = "EventCategory";
    /**
    * Url Prefix: &quot;/contributors&quot;
    */
    UrlEntityType[UrlEntityType["Contributors"] = 11] = "Contributors";
    /**
    * Url Prefix: &quot;/contributor&quot;
    */
    UrlEntityType[UrlEntityType["Contributor"] = 12] = "Contributor";
    /**
    * Url Prefix: &quot;/videos&quot;
    */
    UrlEntityType[UrlEntityType["Video"] = 13] = "Video";
    /**
    * Url Prefix: &quot;/products&quot;. A variant page (BW-8416) shares the product prefix, so a slug is unique across
            Product and ProductDimension rules of a language.
    */
    UrlEntityType[UrlEntityType["ProductDimension"] = 14] = "ProductDimension";
    /**
    * Default value for unknown data
    */
    UrlEntityType[UrlEntityType["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(UrlEntityType || (UrlEntityType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {number}
 */
var UrlTargetOptions;
(function (UrlTargetOptions) {
    UrlTargetOptions[UrlTargetOptions["_blank"] = 1] = "_blank";
    UrlTargetOptions[UrlTargetOptions["_self"] = 2] = "_self";
    UrlTargetOptions[UrlTargetOptions["_parent"] = 3] = "_parent";
    UrlTargetOptions[UrlTargetOptions["_top"] = 4] = "_top";
    UrlTargetOptions[UrlTargetOptions["_framename"] = 5] = "_framename";
    /**
    * Default value for unknown data
    */
    UrlTargetOptions[UrlTargetOptions["unknown_default_open_api"] = 11184809] = "unknown_default_open_api";
})(UrlTargetOptions || (UrlTargetOptions = {}));

export { AccessRuleType, Action, ActivityAction, ApplyToSiteMode, AttributeType, AuditActorKind, AvailabilityStatus, BannerPersonsEntityType, BinaryRepoEntityType, BizUserType, BizwebEntityType, BooleanFilter, CardNotificationsStatus, CategoryFilterMode, ConditionCombinationMode, Configuration, ContactMethod, CouponEventType, CouponValidationErrorCode, CustomContentSchema, CustomDeleteBehavior, CustomerTierCriteriaType, DimensionType, DimensionValueGroupingType, DiscountApplicationMethod, DiscountCapBasis, DiscountCapConstraint, DiscountMode, DiscountTarget, EventPlace, EventSubscriptionStatus, FilterType, ImportMode, IneligibilityReason, LoyaltyEventType, LoyaltyHistoryReason, LoyaltyHistoryStatus, LoyaltyPointsEventCode, McpKeyIdentityContext, MethodOfPurchase, NewsEntriesSource, NewsEntryProductsDisplayMode, NewsEntryVisibility, NotificationPersonsEntityType, OnlinePaymentType, OrderStatus, OrderWithdrawalRequestStatus, PointStatus, PriceTaxMode, ProductCouponApplicationScope, ProductSortType, ProductType, PromotionPolicyTypes, ReceiptType, ReferralStatus, RefundExecutionMethod, ReturnDesiredAction, ReturnItemStatus, ReturnMethod, ReturnPolicyEntityType, ReturnReason, ReturnSettingValueKind, ReturnTransitionRejection, ReviewReportReason, ReviewStatus, SettingValueType, ShipmentTrackingAvailability, ShipmentTrackingStatus, SmsNotificationChannel, TaxStatus, TaxType, TemplateEngineType, UrlEntityType, UrlTargetOptions, UserLinkedEntityType, ValueDataType };
//# sourceMappingURL=index.js.map
